import {FlexList} from "../../../components/flexlist/FlexList";
import {
   AddressInfo,
   EnumAddressInfoRefType,
   ParcelFragment,
   SortFindManyParcelInput,
   useParcelLogisticsPartnerNameQuery,
   useParcelShopNameQuery,
   useParcelsListLazyQuery
} from "../../../Queries";
import {FlexListColumn} from "../../../components/flexlist/FlexTypes";
import {useCallback} from "react";
import dayjs from "dayjs";
import {Box} from "@mui/material";

type ParcelsListProps = {
   brandHouseId: string
   shopId?: string
   shopNames?: Record<string, string>
}

const PAGE_SIZE = 20;
export const ParcelsList = ({brandHouseId, shopId, shopNames}: ParcelsListProps) => {
   const [fetchMore] = useParcelsListLazyQuery()

   const columns: FlexListColumn<ParcelFragment>[] = [{
      id: 'date',
      field: 'parcelDate',
      label: 'Parcel date',
      render: (date) => {
         return dayjs(date).format('DD. MMM YYYY  HH:mm')
      }
   }, {
      id: 'sender',
      label: 'Sent by',
      get: (row) => row.shippingLabel?.sender || row.sender,
      render: (sender) => {
         return <AddressInfoView address={sender}/>
      }
   }, {
      id: 'receiver',
      label: 'To',
      get: (row) => row.shippingLabel?.receiver || row.receiver,
      render: (receiver) => {
         return <AddressInfoView address={receiver}/>
      }
   }, {
      id: 'carrier',
      label: 'Carrier',
      get: (row) => row.shippingCarrier?.name || '-',
   }, {
      id: 'trackingCode',
      label: 'Tracking code',
      get: (row) => row.shippingLabel?.packageCode || '-',
   }, ...(shopNames ? [{
      id: 'shop',
      label: 'Shop',
      get: (row: ParcelFragment) => shopNames[row.shopId] || '-',
   }] : [])];

   const onRequestData = useCallback(async (search: string | undefined, sort: string | undefined, page: number, filter: any) => {
      const {data} = await fetchMore({
         variables: {
            page: page,
            sort: (sort as SortFindManyParcelInput) || SortFindManyParcelInput._ID_DESC,
            perPage: PAGE_SIZE,
            search: search,
            filter: {
               brandHouseId,
               ...(shopId ? {shopId} : {}),
               ...filter
            }
         }
      });
      return {
         data: data?.ParcelsPagination?.items || [],
         totalCount: data?.ParcelsPagination?.count || 0
      }
   }, [brandHouseId, fetchMore, shopId]);

   const onSelectRow = (row: ParcelFragment) => {

   }

   return <FlexList globalId={"parcelList"} onSelectRow={onSelectRow} columns={columns} itemsPerPage={20}
                    onRequestData={onRequestData}/>
}

const AddressRefName = ({refId, refType}: { refId: string, refType: EnumAddressInfoRefType }) => {
   const {data: shopData} = useParcelShopNameQuery({
      variables: {id: refId},
      skip: refType !== EnumAddressInfoRefType.SHOP,
   });
   const {data: lpData} = useParcelLogisticsPartnerNameQuery({
      variables: {id: refId},
      skip: refType !== EnumAddressInfoRefType.LOGISTICSPARTNER,
   });

   if (refType === EnumAddressInfoRefType.SHOP) {
      return <>{shopData?.ShopById?.name || '...'}</>;
   }
   if (refType === EnumAddressInfoRefType.LOGISTICSPARTNER) {
      return <>{lpData?.LogisticsPartner?.name || '...'}</>;
   }
   return null;
};

const AddressInfoView = ({address}: { address: AddressInfo }) => {
   if (address?.refId && address?.refType) {
      return <AddressRefName refId={address.refId} refType={address.refType}/>;
   }

   return <Box>
      <Box>
         {address?.name} ({address?.mail})
      </Box>
      <Box>
         {address?.attention}
      </Box>
      <Box>
         {address?.add1}
      </Box>
      <Box>
         {address?.add2}
      </Box>
      <Box>
         {address?.zipCode} {address?.city}
      </Box>
      <Box>
         {address.countryCode}
      </Box>
   </Box>
}
